import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

/**
 * Handles SEO relation slug routes and rewrites them into SPA query params
 * so the Home page can bootstrap the CountryRelationsContainer view.
 */
export default function CountryRelationSlugRedirect({ mode = 'page' }) {
  const navigate = useNavigate();
  const params = useParams();

  useEffect(() => {
    const search = new URLSearchParams();
    const countrySlug = params.countrySlug;

    if (countrySlug) {
      search.set('country', countrySlug);
    }

    if (mode === 'bilateral') {
      if (params.otherSlug) {
        search.set('relationsWith', params.otherSlug);
      }
    } else if (params.relationSlug) {
      search.set('relationPage', params.relationSlug);
    }

    navigate({ pathname: '/', search: `?${search.toString()}` }, { replace: true });
  }, [mode, navigate, params.countrySlug, params.otherSlug, params.relationSlug]);

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      Redirecting…
    </div>
  );
}
